import { render } from "./text2.vue?vue&type=template&id=42ce0673&scoped=true"
import script from "./text2.vue?vue&type=script&lang=js"
export * from "./text2.vue?vue&type=script&lang=js"

import "./text2.vue?vue&type=style&index=0&id=42ce0673&scoped=true&lang=css"

import exportComponent from "/Users/user/Desktop/Проекты/territory_transport/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42ce0673"]])

export default __exports__